import { Pipe, PipeTransform } from '@angular/core';

import { PhonePipe }             from './phone.pipe';
import { PhonePipeOptionsModel } from './typings/phone-pipe.options';
import { SessionService }        from '../../sessions/session.service';

@Pipe({
  name: 'mobilePhone'
})
export class MobilePhonePipe extends PhonePipe implements PipeTransform {
  constructor(
    sessionService: SessionService
  ) {
    super(sessionService);
  }

  transform( value : string, options : PhonePipeOptionsModel = this._defaultOptions ) : string {
    const country    = this.sessionService.countryValidation();
    const mask       = country.mobile.mask || country.phone.mask;
    const validation = country.mobile.validation || country.phone.validation;

    const regexObj = new RegExp(validation);

    return this.format(value, mask, regexObj, options);
  }
}
